module.exports = __webpack_public_path__ + "static/img/n11-134.e69a965.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/n11-134.jpg
// module id = y0IP
// module chunks = 2